import React, { useContext } from 'react';
import { Formik } from 'formik';

import { UserContext } from '../../context/userContext';

import FormInput from '../form/input';

const WalletBankDetailsModal = () => {
  const { handleWalletBankDetailsModal, walletBankDetails } = useContext(UserContext);

  return (
    <div className={walletBankDetails ? 'show' : 'hidden'}>
      <div className="fixed modal-bg z-50">
        <div className="flex flex-wrap items-center justify-center h-screen w-screen">
          <div className="relative w-125 p-16 mx-auto bg-white rounded">
            <div className="my-6 text-center">
              <h4 className="font-bold">Update your Bank Details</h4>
              <p>Make changes to your basic info here.</p>
            </div>

            <button
              className="absolute right-0 top-0 pr-6 pt-6 text-green-600 focus:outline-none"
              onClick={handleWalletBankDetailsModal}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-x"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>

            <Formik
              initialValues={{
                bankName: 'Bank Name',
                branch: 'Bank Branch',
                accountName: 'Account Name',
                accountNumber: 'Account Number'
              }}
            >
              {({ values, handleSubmit, handleChange, handleBlur }) => (
                <form
                  onSubmit={handleSubmit}
                  className="flex flex-wrap mt-4 justify-center items-center"
                >
                  <div className="w-1/2 pr-2 mb-6">
                    <FormInput
                      type="text"
                      name="name"
                      id="name"
                      blur={handleBlur}
                      change={handleChange}
                      placeholder="Bank Name"
                      title="Bank Name"
                      inputValue={values.bankName}
                      inputType
                    />
                  </div>

                  <div className="w-1/2 pl-2 mb-6">
                    <FormInput
                      type="text"
                      name="branch"
                      id="branch"
                      blur={handleBlur}
                      change={handleChange}
                      placeholder="Bank Branch"
                      title="Bank Branch"
                      inputValue={values.branch}
                      inputType
                    />
                  </div>

                  <div className="w-1/2 pr-2 mb-4">
                    <FormInput
                      type="text"
                      name="accountName"
                      id="accountName"
                      blur={handleBlur}
                      change={handleChange}
                      placeholder="Account Name"
                      title="Account Name"
                      inputValue={values.accountName}
                      inputType
                    />
                  </div>

                  <div className="w-1/2 pl-2 mb-4">
                    <FormInput
                      type="text"
                      name="accountNumber"
                      id="accountNumber"
                      blur={handleBlur}
                      change={handleChange}
                      placeholder="Account Number"
                      title="Account Number"
                      inputValue={values.accountNumber}
                      inputType
                    />
                  </div>

                  <div className="flex flex-wrap justify-content-center items-center mt-6">
                    <button className="py-5 px-16 mr-4 bg-cf-300 text-white text-base rounded focus:outline-none">
                      Save
                    </button>
                    <button
                      onClick={handleWalletBankDetailsModal}
                      className="py-5 px-16 text-base font-bold text-cf-300 bg-cf-200 focus:outline-none"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletBankDetailsModal;
